//import './Menu.css';
import './asset/css/Menu.css'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'

import Users from "./pages/Users";

import Indent from "./pages/Indent";

import Closeapp from './pages/Closeapp';
import Modal from './pages/Modal';


import Hdr from './shared/Hdr';
import Protected from './Protected'
import Sidebar from './components/Sidebar';
import ToolCategory from "./pages/ToolCategory";
import ToolMaster from "./pages/ToolMaster";
import StoreMaster from "./pages/StoreMaster";
import Transaction from "./pages/Transaction";
import Dashboard from "./pages/Dashboard";
import Inventory from "./pages/Inventory";
import FA from "./pages/FA";
//import EOP2 from './pages/EOP2';
import ToolHistory from './pages/ToolHistory';
//import Motion from "./pages/Motion";
import SiteIssu from './pages/SiteIssue';
import Reports from './pages/Reports';
import Rolemgmnt from './pages/Rolemgmnt';

function App() {
  
  return (
    <>
      <Router>
      <div className="row">
      <Hdr />
      <div className='c12-l-2'>
        <Sidebar /> 
      </div>
      <div className="c12-l-10">
          <Routes>
            <Route path="/" element={<Protected Cmp={Dashboard} />} />
            <Route path="/Users" element={<Protected Cmp={Users} />} / >
            <Route path="/ToolCategory" element={<Protected Cmp={ToolCategory} />} />
            <Route path="/ToolMaster" element={<Protected Cmp={ToolMaster} />} />
            <Route path="/StoreMaster" element={<Protected Cmp={StoreMaster} />} />
            <Route path="/Indent" element={<Protected Cmp={Indent} />} />
            <Route path="/Transaction" element={<Protected Cmp={Transaction} />} />
            <Route path="/Dashboard" element={<Protected Cmp={Dashboard} />} />
            <Route path="/Inventory" element={<Protected Cmp={Inventory} />} />
            <Route path="/ToolHistory" element={<Protected Cmp={ToolHistory} />} />
            <Route path="/SiteIssue" element={<Protected Cmp={SiteIssu} />} />
            <Route path="/Reports" element={<Protected Cmp={Reports} />} />

            <Route path="/Setting/2FA" element={<FA />} />
            <Route path="/Closeapp" element={<Protected Cmp={Closeapp} />} /> 
            <Route path="/Modal" element={<Protected Cmp={Modal}/>} /> 
            <Route path="/Role Management" element={<Protected Cmp={Rolemgmnt}/>} /> 
         {/*   <Route path="/EOP2" element={<Protected Cmp={EOP2}/>} />  */}

         <Route path="/Dashboard" element={<Protected Cmp={Dashboard}/>} />   

          </Routes>
        </div>
        </div>
      </Router>
    </>
  );
}

export default App;
